// @ts-nocheck
import PropTypes from "prop-types";
import {useCallback, useEffect, useState} from "react";

const useIsMobile = ({breakpoint = 768, ssrFallback = false} = {}) => {
  const getInitial = useCallback(() => {
    if (typeof window === "undefined") return ssrFallback;

    return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
  }, [breakpoint, ssrFallback]);

  const [isMobile, setIsMobile] = useState(getInitial);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const onChange = e => setIsMobile(e.matches);

    mq.addEventListener("change", onChange);

    setIsMobile(mq.matches);

    return () => mq.removeEventListener("change", onChange);
  }, [breakpoint]);

  return isMobile;
};

useIsMobile.propTypes = {
  breakpoint: PropTypes.number,
  ssrFallback: PropTypes.bool,
};

export default useIsMobile;
